import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InicioComponent } from './components/inicio/inicio.component';
import { AsignarComponent } from './components/asignar/asignar.component';

import { DetalleOirsComponent } from './components/detalle-oirs/detalle-oirs.component';
import { VisualizarComponent } from './components/visualizar/visualizar.component';
import { LoginComponent } from './components/login/login.component';
import { AuthGuardService } from './services/auth-guard.service';


const routes: Routes = [
  {
    path: 'inicio', component: InicioComponent, canActivate: [AuthGuardService], data: { privileges: ['601', '105'] }
  },
  {
    path: 'asignar/:IDSolicitud', component: AsignarComponent, canActivate: [AuthGuardService], data: { privileges: ['601'] }
  },
  {
    path: 'responder/:IDSolicitud', component: DetalleOirsComponent, canActivate: [AuthGuardService], data: { privileges: ['601', '105'] }
  },
  {
    path: 'ver/:IDSolicitud', component: VisualizarComponent, canActivate: [AuthGuardService], data: { privileges: ['601', '105'] }
  },

  {
    path: 'login/:token', component: LoginComponent
  },
  {
    path: 'login', component: LoginComponent
  },
  { path: '**', pathMatch: 'full', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
